import React from 'react';
import PropTypes from 'prop-types';
import BaseModal from 'jsx/elements/modals/BaseModal';
import Button from 'jsx/elements/buttons/Button';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';
import './Modal.less';

export default function Modal({
  isOpen,
  variant = 'c',
  header,
  children,
  onCancelClick,
  onConfirmClick,
  footer,
  disableSubmit,
  disableActions,
  allowClickOverlay,
}) {
  const { t } = useLocale();
  return (
    <BaseModal isOpen={isOpen} allowClickOverlay={allowClickOverlay} onCloseClick={onCancelClick}>
      <div id={`modal-variant-${variant}`}>
        <div id="modal-header">
          <h2>{header}</h2>
        </div>
        <div id="modal-main">{children}</div>
        <div id="modal-footer">
          {footer || (
            <>
              <Button
                disabled={disableActions}
                text={t('modal_cancel')}
                color="clear"
                onClick={onCancelClick}
              />
              <Button
                text={t('modal_confirm')}
                color="red"
                onClick={onConfirmClick}
                disabled={disableActions || disableSubmit}
              />
            </>
          )}
        </div>
      </div>
    </BaseModal>
  );
}

Modal.propTypes = {
  variant: PropTypes.string,
};
